module.exports = __webpack_public_path__ + "static/media/about-21.71f54dc2.png";